import { render, staticRenderFns } from "./SwapRoutes.vue?vue&type=template&id=5b3fae97&scoped=true"
import script from "./SwapRoutes.vue?vue&type=script&lang=js"
export * from "./SwapRoutes.vue?vue&type=script&lang=js"
import style0 from "./SwapRoutes.vue?vue&type=style&index=0&id=5b3fae97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3fae97",
  null
  
)

export default component.exports